<template>
  <d-row>
    <d-col cols="12" class="mb-2" v-for="(condition, index) in items" :key="index">
      <d-row class="tag_select" alignV="center">
        <d-col cols="9" class="">
          <autocomplete
            :ref="`completeConditions_${prefix}_${index}`"
            placeholder="Tag"
            item-show="name"
            :parameter="index"
            :items="tags"
            :on-input="onInput"
            :on-select="setTag"
          ></autocomplete>
        </d-col>
        <d-col cols="3" class="p-0">
          <d-button type="button" theme="secondary" class="mr-2" outline v-if="index + 1 === items.length" size="sm" @click="addRow">e</d-button>
          <d-button type="button" theme="danger" outline size="sm" v-if="index !== 0" @click="removeRow(index)"><i class="fas fa-trash"></i></d-button>
        </d-col>
      </d-row>
    </d-col>
  </d-row>
</template>

<script>
import { mapActions } from 'vuex';
import Autocomplete from '_shared/Autocomplete.vue';
import { TAG_FILTER_ITEM_MODEL } from '../TagModel';

export default {
  name: 'tag-select',
  components: {
    Autocomplete,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    prefix: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      model: null,
    };
  },
  computed: {
    tags() {
      const { tagList } = this.$store.state.feed;
      if (tagList) {
        return tagList;
      }
      return [];
    },
  },
  methods: {
    ...mapActions([
      'getTagList',
    ]),
    addRow() {
      this.items.push({ ...TAG_FILTER_ITEM_MODEL });
    },
    removeRow(index) {
      this.items.splice(index, 1);
      if (this.items.length === 0) {
        this.addRow();
      }
    },
    onInput(search) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.getTagList(search);
      }, 500);
    },
    setAutocomplete() {
      this.items.map((item, index) => {
        if (this.$refs[`completeConditions_${this.prefix}_${index}`][0] && item.name) {
          this.$refs[`completeConditions_${this.prefix}_${index}`][0].$refs.input.value = item.name;
        }
        return item;
      });
    },
    setTag(tag, index) {
      this.items[index] = tag;
      this.$emit('update:items', this.items);
    },
  },
  mounted() {
    this.setAutocomplete();
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}

button {
  cursor: pointer;
}
</style>
